import { defaultTo } from 'lodash';
import { IModel, Model, ModelRecord } from './Model';

export interface ICallOriginModel extends IModel {
  callOriginId: number;
  name: string;
  isSystemGenerated: boolean;
}

export class CallOriginModel
  extends Model
  implements ModelRecord<ICallOriginModel>
{
  callOriginId: number;
  name: string;
  isSystemGenerated: boolean;

  constructor(params?: Partial<ICallOriginModel>) {
    super(params);

    this.callOriginId = defaultTo(params?.callOriginId, 0);
    this.name = defaultTo(params?.name, '');
    this.isSystemGenerated = defaultTo(params?.isSystemGenerated, false);
  }
}
